export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Temukan informasi mengenai Layanan Sistem Pengembangan Kompetensi ASN melalui SIBangkom, untuk meningkatkan keterampilan dan kapabilitas Aparatur Sipil Negara."},{"property":"og:title","content":"SIBangkom | Lembaga Administrasi Negara"},{"property":"og:description","content":"SIBangkom menyediakan layanan untuk pengembangan kompetensi ASN demi pelayanan publik yang lebih baik."},{"property":"og:image","content":"/images/favicon.png"},{"property":"og:url","content":"https://sibangkom.lan.go.id"},{"property":"og:type","content":"website"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"SIBangkom | Lembaga Administrasi Negara"},{"name":"twitter:description","content":"SIBangkom menyediakan layanan untuk pengembangan kompetensi ASN demi pelayanan publik yang lebih baik."},{"name":"twitter:image","content":"/images/favicon.png"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/images/favicon.png"}],"style":[],"script":[],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1","title":"SIBangkom | Lembaga Administrasi Negara"}

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true